<!--
This component is for creating an agreement
-->
<template>
  <div class="wrapper">
    <dashboardNav/>
    <!-- Page Content  -->
    <div id="content">
      <div class="container">
        <!-- Alerts -->
      </div>

      <!-- Page Content  -->
      <div class="main container">
        <loader :isLoading="isAgreementsRequestInProgress"/>
        <h2>Agreements</h2>
        <div class="line"></div>

        <AgreementForm
          :form="form"
          :isForm="isForm"
          :isEdit="isEdit"
          :error="error"
          :action="action"
          :submitForm="submitForm"
          :cancelEdit="cancelEdit"
          :errorMessage="errorMessage"
          :clearMessage="clearMessage"
          submitButtonName="Add"
        />
        <br/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import {
  ADD_AGREEMENT
} from '@/store/types/actions.type'

import Loader from '@/components/common/Loader'
import DashboardNav from '@/components/common/DashboardNav'
import AgreementForm from '@/components/agreements/AgreementForm'

import Sidebar from '@/containers/dashboard/Sidebar'

import { AuthService } from '@/api/AuthService'

const auth = new AuthService()

export default {
  components: {
    sidebar: Sidebar,
    dashboardNav: DashboardNav,
    Loader,
    AgreementForm
  },
  computed: {
    ...mapGetters(['isAgreementsRequestInProgress'])
  },
  data() {
    return {
      userId: auth.getUserId(),
      companyId: auth.getCompanyId(),
      form: {
        agreement_name: '',
        other_agreement_name: '',
        type: '',
        content: '',
        link: ''
      },
      error: {
        agreement_name: ''
      },
      errorMessage: '',
      action: 'add',
      isForm: true,
      isEdit: false,
      haveError: false,
      haveVuelidateError: false
    }
  },
  methods: {
    clearMessage() {
      this.errorMessage = ''
    },
    createAgreement() {
      var fields = this.form
      fields.user_id = auth.getCompanyId()

      var self = this
      this.$store.dispatch(ADD_AGREEMENT, fields)
      .then(data => {
        if (data.statusCode === 200) {
          self.redirectToPage()
        } else {
          self.errorMessage = data.message
        }
      })
      .catch(e => { self.errorMessage = e })
    },
    cancelEdit(){
      this.redirectToPage()
    },
    submitForm() {
      this.createAgreement()
    },
    redirectToPage() {
      this.$router.push('/dashboard/agreements')
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/agreements/CreateAgreement.vue